export default function RailsApiFactory(
    $http,
    sessionService,
    appCONST
) {
    'ngInject';

    const searchUrl = '/rails/SearchRails';
    const searchInwardEuRailsUrl = '/rails/SearchInwardEuRails';
    const searchExchangeEuRailsUrl = '/rails/SearchExchangeEuRails';
    const searchPageEuRailsUrl = '/rails/SearchPageEuRails';
    const searchLocationUrl = '/staticdata/SearchRailStationsAlternate';
    const previousSearchesUrl = '/UserSearchParameters/UserSearch/AllRails';
    const frequentRailsUrl = '/authorize/GetFrequentLocationsForRails';
    const repeatSearchUrl = '/UserSearchParameters/UserSearch/GetRailSearchRequest';
    const railStaticDataUrl = '/staticdata/GetRailStaticData';
    const railEarlierOrLaterRailsUrl = '/rails/SearchEarlierOrLaterRails ';
    const railTicketDetailsUrl = '/rails/GetTicketDetails';
    const euRailFareTypesUrl = '/rails/GetFareTypes';
    const railReservationPreferenceOptionsUrl = '/rails/GetTicketPreferenceDetails';
    const railTravelCardOptionsUrl = '/rails/GetTravelCardCostDetails';
    const getKioskRailStationsUrl = '/staticdata/GetKioskRailStations';
    const repeatRailSearchByGuidUrl = '/rails/GetRailsSearchByGuid';
    const postCodeLookupUrl = '/rails/PostCodeLookUp';
    const getAllCorpkiosksUrl = '/rails/GetCorporateKiosks';
    const getCorpPrintersUrl = '/rails/GetRemotePrinters';
    const getCurrentUKtimeUrl = '/rails/GetCurrentUKTime';
    const saveAddressUrl = '/Authorize/SaveDeliveryAddress';
    const getAddressTypesUrl = '/Authorize/GetDeliveryAddressesForCurrentUser';
    const journeyChangeEligibilityUrl = '/rails/GetRailJourneyChangeEligibility';
    const getEuRailsJourneyChangeablesUrl = '/rails/GetEuRailsJourneyChangeables';

    const railsApi = {
        search,
        searchInwardEuRails,
        searchExchangeEuRails,
        searchPageEuRails,
        searchLocation,
        getRules,
        getSearchRequestById,
        getFrequentRails,
        getPreviousSearches,
        getStaticData,
        getEarlierOrLaterJournies,
        getTicketRestrictions,
        getFareTypes,
        getRailReservationPreferenceOptions,
        getRailTravelCardOptions,
        getKioskRailStations,
        getRailSearchRequestByGUId,
        getAddressByPostcode,
        getAllCorpkiosks,
        getCorpPrinters,
        getCurrentUKTime,
        saveAddress,
        getAddressTypes,
        getJourneyEligibility,
        getEuRailsJourneyChangeables,
    };

    return railsApi;

    function search(request) {
        return $http.apiPOST(searchUrl, request)
            .then(({data}) => data);
    }

    function searchInwardEuRails(outwardJourneyId, outwardAlternativeIds, searchId) {
        return $http.apiPOST(searchInwardEuRailsUrl, {outwardJourneyId, outwardAlternativeIds, searchId})
            .then(({data}) => data);
    }

    function searchExchangeEuRails(recommendationId, searchSegment, sectionId, changeableUnits, classification) {
        return $http.apiPOST(searchExchangeEuRailsUrl, {recommendationId,
            DepartureDate: searchSegment.DepartureDate,
            DepartureHour: searchSegment.DepartureHour,
            DepartureMinute: searchSegment.DepartureMinute,
            sectionId,
            changeableUnits,
            classification})
            .then(({data}) => data);
    }

    function searchPageEuRails(pageId, pageDirection, searchDirection, searchId, isExchangeSearch) {
        return $http.apiPOST(searchPageEuRailsUrl, {pageId, pageDirection, searchDirection, searchId, isExchangeSearch})
            .then(({data}) => data);
    }

            function searchLocation(request) {
                return $http.apiGET(searchLocationUrl, request);
            }

            function getCurrentUKTime(request) {
                return $http.apiGET(getCurrentUKtimeUrl, request);
            }

            function getRules(params) {
                const isReadOnlyMode = sessionService.getSessionItem('readOnlyMode');
                const anonymousLink = appCONST.serverUrl + '/api/flights/SearchRulesAnonymous';

                const requestData = {
                    FlightRecommendationId: params.recommendationId,
                    FareRecommendationId: params.fareId,
                    FlightGroupIds: params.flightGroups,
                    SearchId: params.searchId,
                    Travelers: {
                        Adult: params.adultCount,
                        Infant: params.infantCount,
                        Child: params.childCount,
                    },
                };

                const requestConfig = {
                    culture: params.culture,
                };

                return (isReadOnlyMode)
                    ? $http.post(anonymousLink, requestData, requestConfig)
                    : $http.apiPOST('/flights/SearchRules', requestData);
            }

            function getSearchRequestById(id) {
                const params = {
                    searchParamId: id,
                };

                return $http.apiGET(repeatSearchUrl, {params});
            }

            function getRailSearchRequestByGUId(SearchId) {
                return $http.apiPOST(repeatRailSearchByGuidUrl, {SearchId});
            }

            function getFrequentRails() {
                return $http.apiGET(frequentRailsUrl, {noSpinner: true});
            }

            function getPreviousSearches(amount, type) {
                const params = {
                    topResults: amount,
                    searchType: type,
                };

                return $http.apiGET(previousSearchesUrl, {params});
            }

            function getStaticData() {
                return $http.apiGET(railStaticDataUrl, {cache: true});
            }

            function getEarlierOrLaterJournies(request, date, time, direction, IsEarlierJourney) {
                const earlierRequest = {
                    SearchRailRequest: request,
                    NewTravelDate: date,
                    NewTravelTime: time,
                    Direction: direction,
                    IsEarlierJourney,
                };
                return $http.apiPOST(railEarlierOrLaterRailsUrl, earlierRequest);
            }

            function getTicketRestrictions(ticketTypeCode, tripId) {
                return $http.apiGET(railTicketDetailsUrl, {params: {ticketTypeCode, tripId}})
                    .then(({data}) => data);
            }

            function getFareTypes(fareTypeIds) {
                return $http.apiPOST(euRailFareTypesUrl, fareTypeIds)
                    .then(({data}) => data);
            }


            function getRailReservationPreferenceOptions(MsgNum) {
                return $http.apiGET(railReservationPreferenceOptionsUrl, {params: {MsgNum}});
            }

            function getRailTravelCardOptions(MsgNum, validFor, TnC) {
                const RailTravelCardRequest = {};
                RailTravelCardRequest.MsgNum = MsgNum;
                RailTravelCardRequest.ValidFor = validFor;
                RailTravelCardRequest.TermsAndConditions = TnC;
                return $http.apiPOST(railTravelCardOptionsUrl, RailTravelCardRequest);
            }

            function getKioskRailStations() {
                return $http.apiGET(getKioskRailStationsUrl, {cache: true});
            }

            function getAddressByPostcode(postCode) {
                return $http.apiPOST(postCodeLookupUrl, {postCode});
            }

            function getAllCorpkiosks() {
                return $http.apiGET(getAllCorpkiosksUrl, {cache: true});
            }

            function getCorpPrinters() {
                return $http.apiGET(getCorpPrintersUrl, {cache: true});
            }

            function saveAddress(address) {
                return $http.apiPOST(saveAddressUrl, address);
            }

            function getAddressTypes() {
                return $http.apiGET(getAddressTypesUrl);
            }

            function getJourneyEligibility(railRecommendationId, tripId) {
                const params = {railRecommendationId, tripId};
                return $http.apiGET(journeyChangeEligibilityUrl, {params})
                    .then(({data}) => data);
            }

            function getEuRailsJourneyChangeables(railRecommendationId, tripId) {
                const params = {railRecommendationId, tripId};
                return $http.apiGET(getEuRailsJourneyChangeablesUrl, {params})
                    .then(({data}) => data);
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/base/services/railsApiService.js